// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'CiscoSans', 'CiscoSans Fallback'"},"className":"__className_b49db9"};